document.addEventListener('DOMContentLoaded', function () {
    // Selecciona todos los elementos del mega menú
    const megaMenus = document.querySelectorAll('header-menu details.mega-menu');

    // Si no hay menús, no hagas nada
    if (!megaMenus.length) {
        return;
    }

    megaMenus.forEach(menu => {
        // Abrir el menú cuando el ratón entra en el elemento
        menu.addEventListener('mouseenter', function () {
            this.setAttribute('open', true);
        });

        // Cerrar el menú cuando el ratón sale del elemento
        menu.addEventListener('mouseleave', function () {
            this.removeAttribute('open');
        });
    });
});